import { ParticipantGroupService } from '@api/domains/participant-group/services';
import { useAxios } from '@api/hooks';
import { useMemo } from 'react';

export const useParticipantGroupApi = () => {
  const axios = useAxios();
  return useMemo(() => new ParticipantGroupService(axios), []);
};
